import { NewDonationFormPage } from './NewDonationFormPage'

export const DonationFormContainer = () => {
  return <NewDonationFormPage />
}
